import ModalComponent from "../../Components/ModalComponent";
import { Button, Col, Form, Row, Spin } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../apis/store";
import { InputOTP } from "antd-input-otp";
import { showNotitfication } from "../../utils/Utils";
import { useTranslation } from "react-i18next";
import { toRegenerateOtp, toSignupOTP } from "../../apis/actions/auth.actions";
import { useCookies } from "react-cookie";
import { useLocation, useNavigate } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import { resolveAuthReturnPath } from "../../utils/authReturnPath";

interface RegisterOtpModalProps {
  onClose: () => void;
  open?: boolean;
  phone?: string;
  OtpTimeLeft?: number;
  name?: string;
  password?: string;
}

const RegisterOtpModal = ({
  open,
  onClose,
  phone,
  OtpTimeLeft,
  name,
  password,
}: RegisterOtpModalProps) => {
  const [form] = Form.useForm();
  const otpValue = Form.useWatch("otp", form);
  const [loadingReg, setLoadingReg] = useState(false);
  const [timeLeft, setTimeLeft] = useState<number>(0);
  const [cookies, setCookie] = useCookies(["apiKey"]);
  const [otpError, setOtpError] = useState<string | null>(null); // <-- NEW STATE

  const navigate = useNavigate();
  const location = useLocation();
  const isOtpInvalid =
    !otpValue ||
    otpValue.length !== 4 ||
    otpValue.includes(undefined) ||
    otpValue.includes("");
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch<AppDispatch>();
  const { loading } = useSelector((state: RootState) => state.login);
  const timerRef = useRef<NodeJS.Timeout | null>(null);
  useEffect(() => {
    if (OtpTimeLeft) {
      setTimeLeft(OtpTimeLeft);
    } else {
      setTimeLeft(0);
      if (timerRef.current) clearInterval(timerRef.current);
    }
  }, [OtpTimeLeft, open]);
  const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
  useEffect(() => {
    if (timeLeft > 0) {
      timerRef.current = setInterval(() => {
        setTimeLeft((prev) => prev - 1);
      }, 1000);
    }

    return () => {
      if (timerRef.current) clearInterval(timerRef.current);
    };
  }, [timeLeft]);
  const handleVerifyOtp = async () => {
    const otp = form.getFieldValue("otp");
    form.validateFields();

    if (!otp || otp.length !== 4 || otp.includes(undefined) || otp.includes(""))
      return form.setFields([
        {
          name: "otp",
          errors: ["الرجاء إدخال رمز التحقق"],
        },
      ]);
    else {
      const success = (await dispatch(
        toSignupOTP({
          data: {
            otp: `${otp[0]}${otp[1]}${otp[2]}${otp[3]}`,
            login: phone,
            name,
            password,
            code: "966",
            tz,
          },
          lang: i18n.language,
        })
      )) as any;

      const verifyOtp = success?.payload?.data?.result;
      if (verifyOtp?.code === 200) {
        setCookie("apiKey", verifyOtp?.api_key);
        setOtpError(null); // ✅ Clear error message if success
        showNotitfication(
          i18n.language === "ar"
            ? `تم التسجيل بنجاح، مرحبًا ${name}!`
            : `Sign up successful, welcome ${name}!`,
          "success"
        );
        setTimeout(() => {
          navigate(resolveAuthReturnPath(location.state, "/add-car"), {
            replace: true,
          });
        }, 2800);
        form.resetFields();
      } else {
        // ✅ If OTP invalid => reset timer and show error message
        if (verifyOtp?.code === 401) {
          setTimeLeft(0);
          setOtpError(
            i18n.language === "ar"
              ? "لقد تجاوزت عدد المحاولات المسموح بها. يرجى طلب رمز تحقق جديد."
              : "You have exceeded the allowed number of attempts. Please request a new verification code."
          );
        } else {
          setOtpError(null); // ✅ Hide red error when it's not a 401 issue
          showNotitfication(verifyOtp?.message, "error");
        }
      }
    }
  };
  const RegenrateOtp = async () => {
    setOtpError(null);
    setLoadingReg(true);
    const success = (await dispatch(
      toRegenerateOtp({
        data: { mobile: phone, code: "966" },
        lang: i18n.language,
      })
    )) as any;

    const RegenerateOtp = success?.payload?.data?.result;

    if (RegenerateOtp?.code === 200) {
      const seconds = RegenerateOtp?.time_left || 0;
      setTimeLeft(seconds);
    } else {
      form.resetFields();
      const seconds = RegenerateOtp?.time_left || 0;
      setTimeLeft(seconds);
      showNotitfication(RegenerateOtp?.message, "error");
    }

    setLoadingReg(false);
  };
  const handleClose = () => {
    setOtpError(null);
    form.resetFields();
    setTimeLeft(0);
    onClose?.();
  };
  return (
    <>
      <ModalComponent
        width={450}
        title=""
        open={open}
        onClose={handleClose}
        closeOnOutsideClick={true}
        modalStyle={{ top: 90 }}
      >
        <div
          className="otp-modal-content "
          style={{
            direction: i18n.language === "ar" ? "rtl" : "ltr",
            textAlign: i18n.language === "ar" ? "right" : "left",
          }}
        >
          <div
            className="otp-modal-header "
            style={{ textAlign: "center", marginBottom: "1rem" }}
          >
            <h6
              style={{ fontWeight: 600, marginTop: "2rem" }}
              className="ac--font-expo"
            >
              {i18n.language === "ar"
                ? "قم بتأكيد رقم الجوال"
                : "Verify your mobile number"}
            </h6>{" "}
            <p className="ac--font-expo">
              {i18n.language === "ar"
                ? `أدخل رمز التحقق المكون من 4 أرقام والمرسل إلى`
                : "Enter the 4-digit OTP sent to"}
              <br />
              <strong className="ac--font-expo">{phone}</strong>
            </p>
          </div>

          <Form form={form} layout="vertical">
            <Form.Item
              name="otp"
              rules={[{ required: true, message: t("otp.warning") }]}
              style={{ textAlign: "center", direction: "ltr" }}
            >
              <InputOTP autoFocus inputMode="tel" length={4} />
            </Form.Item>

            <div
              style={{
                textAlign: "center",
                marginTop: "2rem",
              }}
            >
              {timeLeft > 0 ? (
                <span className="ac--font-expo" style={{ color: "#999" }}>
                  {i18n.language === "ar"
                    ? `ستنتهي صلاحية رمز التحقق خلال ${timeLeft} ثانية`
                    : `OTP will expire in ${timeLeft} seconds`}
                </span>
              ) : !loadingReg ? (
                <>
                  {otpError ? (
                    // 🔹 Show red error message when attempts are exceeded
                    <>
                      <span
                        className="ac--font-expo"
                        style={{
                          color: "red",
                          //fontWeight: "bold",
                          display: "block",
                          marginBottom: "6px",
                        }}
                      >
                        {otpError}
                      </span>
                      <span
                        className="ac--font-expo"
                        style={{
                          color: "#5C9DFF",
                          cursor: "pointer",
                          fontWeight: "bold",
                        }}
                        onClick={RegenrateOtp}
                      >
                        {i18n.language === "ar"
                          ? "إعادة إرسال رمز التحقق"
                          : "Resend OTP"}
                      </span>
                    </>
                  ) : (
                    <>
                      <span
                        className="ac--font-expo"
                        style={{ display: "block" }}
                      >
                        {i18n.language === "ar"
                          ? "لم تتلقى رمز التحقق؟"
                          : "Didn't get the OTP?"}
                      </span>
                      <span
                        className="ac--font-expo"
                        style={{
                          color: "#5C9DFF",
                          cursor: "pointer",
                          fontWeight: "bold",
                        }}
                        onClick={RegenrateOtp}
                      >
                        {i18n.language === "ar"
                          ? "إعادة إرسال رمز التحقق"
                          : "Resend OTP"}
                      </span>
                    </>
                  )}
                </>
              ) : (
                <Spin size="small" className="me-2" />
              )}
            </div>

            <div
              style={{
                background: "#FFF9E5",
                padding: "5px",
                borderRadius: "6px",
                display: "flex",
                alignItems: "center",
                marginTop: 20,
                fontSize: 12,
              }}
            >
              <img
                src="/assets/imgs/template/icons/light.svg"
                alt="tip"
                style={{ width: 16, height: 16 }}
              />
              <span className="ac--font-expo">
                {i18n.language === "ar"
                  ? "يحمي رمز التحقق حسابك من الوصول غير المصرح به"
                  : "OTP verification protects your account from unauthorized access."}
              </span>
            </div>

            <Row justify={"center"} style={{ marginTop: "1rem" }}>
              <Col span={22}>
                <Button
                  style={{ width: "100%" }}
                  type="primary"
                  className=" ac--btn-primary-jflatbold mt-30"
                  onClick={handleVerifyOtp}
                  disabled={
                    isOtpInvalid ||
                    loading ||
                    otpError !== null ||
                    timeLeft == 0
                  }
                >
                  {i18n.language === "ar" ? "تأكيد" : "Verify"}
                </Button>
              </Col>
            </Row>
          </Form>
        </div>
      </ModalComponent>
    </>
  );
};

export default RegisterOtpModal;
